import { Link } from "react-router-dom";

export const SoftSkillsAndResourcesOfTheTeachetConst = {
  path: "/single-page/soft-skills-and-resources-of-the-teachet",
  title: "МЯГКИЕ НАВЫКИ И РЕСУРСНОСТЬ ПРЕПОДАВАТЕЛЯ",
  contentJSX: (
    <>
      <h2>МЯГКИЕ НАВЫКИ И РЕСУРСНОСТЬ ПРЕПОДАВАТЕЛЯ</h2>
      <p>Общий объём: 144 академических часа</p>
      <p>Формат: онлайн / офлайн</p>
      <p>Язык: русский / английский</p>
      <p>Итог: Международный сертификат</p>
      <h2>I. ЭМОЦИОНАЛЬНЫЙ ИНТЕЛЛЕКТ И КОММУНИКАЦИЯ — 36 ЧАСОВ</h2>
      <ul className="number">
        <li>Развитие эмпатии и саморегуляции – 12 ч</li>
        <li>Эффективное слушание и обратная связь – 12 ч</li>
        <li>Конфликтология и психология взаимодействия – 12 ч</li>
      </ul>
      <h2>II. ЛИЧНАЯ ЭФФЕКТИВНОСТЬ И СТРЕСС-МЕНЕДЖМЕНТ — 30 ЧАСОВ</h2>
      <ul className="number">
        <li>Тайм-менеджмент и приоритизация задач – 12 ч</li>
        <li>Работа с выгоранием и профилактика стресса – 12 ч</li>
        <li>Техники ресурсного состояния – 6 ч</li>
      </ul>
      <h2>III. НАСТАВНИЧЕСТВО И КОМАНДНАЯ РАБОТА — 30 ЧАСОВ</h2>
      <ul className="number">
        <li>Принципы коучинга и тьюторства – 12 ч</li>
        <li>Развитие командного духа – 6 ч</li>
        <li>Фасилитация и проектное взаимодействие – 6 ч</li>
        <li>Мотивация студентов и педагогических команд – 6 ч</li>
      </ul>
      <h2>IV. КРЕАТИВНОСТЬ И SOFT SKILLS В ПРЕПОДАВАНИИ — 24 ЧАСА</h2>
      <ul className="number">
        <li>Мышление за пределами шаблонов – 6 ч</li>
        <li>Публичные выступления и сторителлинг – 6 ч</li>
        <li>Креативные методики в образовательной среде – 6 ч</li>
        <li>Самопрезентация и развитие личного бренда – 6 ч</li>
      </ul>
      <h2>V. ИНДИВИДУАЛЬНЫЙ ИТОГОВЫЙ ПРОЕКТ — 24 ЧАСА</h2>
      <ul className="number">
        <li>Разработка личного ресурсо-ориентированного плана – 12 ч</li>
        <li>Представление и рефлексия – 12 ч</li>
      </ul>
      <br />
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
    </>
  ),
  contentSearch: `
    МЯГКИЕ НАВЫКИ И РЕСУРСНОСТЬ ПРЕПОДАВАТЕЛЯ 
    Общий объём: 144 академических часа
    Формат: онлайн / офлайн
    Язык: русский / английский
    Итог: Международный сертификат
    I. ЭМОЦИОНАЛЬНЫЙ ИНТЕЛЛЕКТ И КОММУНИКАЦИЯ — 36 ЧАСОВ
    Развитие эмпатии и саморегуляции – 12 ч
    Эффективное слушание и обратная связь – 12 ч
    Конфликтология и психология взаимодействия – 12 ч
    II. ЛИЧНАЯ ЭФФЕКТИВНОСТЬ И СТРЕСС-МЕНЕДЖМЕНТ — 30 ЧАСОВ
    Тайм-менеджмент и приоритизация задач – 12 ч
    Работа с выгоранием и профилактика стресса – 12 ч
    Техники ресурсного состояния – 6 ч
    III. НАСТАВНИЧЕСТВО И КОМАНДНАЯ РАБОТА — 30 ЧАСОВ
    Принципы коучинга и тьюторства – 12 ч
    Развитие командного духа – 6 ч
    Фасилитация и проектное взаимодействие – 6 ч
    Мотивация студентов и педагогических команд – 6 ч
    IV. КРЕАТИВНОСТЬ И SOFT SKILLS В ПРЕПОДАВАНИИ — 24 ЧАСА
    Мышление за пределами шаблонов – 6 ч
    Публичные выступления и сторителлинг – 6 ч
    Креативные методики в образовательной среде – 6 ч
    Самопрезентация и развитие личного бренда – 6 ч
    V. ИНДИВИДУАЛЬНЫЙ ИТОГОВЫЙ ПРОЕКТ — 24 ЧАСА
    Разработка личного ресурсо-ориентированного плана – 12 ч
    Представление и рефлексия – 12 ч
  `,
};
